module.exports = __webpack_public_path__ + "404dc50288c435b069fd6c769d6a733d.png";